var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.3146 3.87853e-07H1.72391C0.771356 0.000632455 -0.000631679 0.773252 3.87853e-07 1.72602V67.3165C0.000632455 68.2693 0.773252 69.0412 1.72602 69.0406H67.3167C68.2693 69.04 69.0412 68.2674 69.0406 67.3146V1.72391C69.04 0.771356 68.2674 -0.000631679 67.3146 3.87853e-07ZM22.4382 65.5886H3.45203V46.6024H22.4382V65.5886ZM22.4382 43.1504H3.45203V25.8902H22.4382V43.1504ZM22.4382 22.4382H3.45203V3.45203H22.4382V22.4382ZM43.1504 65.5886H25.8902V46.6024H43.1504V65.5886ZM43.1504 43.1504H25.8902V25.8902H43.1504V43.1504ZM43.1504 22.4382H25.8902V3.45203H43.1504V22.4382ZM65.5886 65.5886H46.6024V46.6024H65.5886V65.5886ZM65.5886 43.1504H46.6024V25.8902H65.5886V43.1504ZM65.5886 22.4382H46.6024V3.45203H65.5886V22.4382Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataGrid);
export default __webpack_public_path__ + "static/media/dataGrid.a800f6d5e5b23793b9ab39de2a7aa7bf.svg";
export { ForwardRef as ReactComponent };